import React, { useState, useEffect } from "react";
import Sub_header from './Sub_header'

import axios from "axios";


import exportValue from "../apiconfig";
import ReactLoading from 'react-loading';
import Swal from 'sweetalert2'
import Left_panel from "./Left_panel";
import Moment from 'react-moment';
import { el } from "date-fns/locale";

const My_earnings = () => {
    const[state,setState] = React.useState([])
    const[adminstate,setadminState] = React.useState([])
    const [selectedItem, setSelectedItem] = React.useState(null);
    let admindata = {};
if (localStorage.getItem('admin_login')) {
  admindata = JSON.parse(localStorage.getItem('admin_login'));
  console.log("admindata------>  -  ",admindata);
  
}
     const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    
       const toggleSidebar = () => {
           setIsSidebarOpen(!isSidebarOpen);
           const homeSection = document.querySelector('.home-section');
           if (homeSection) {
               homeSection.classList.toggle('sidebar-closed');
           }
       };

       React.useEffect(()=>{
        getAdminDetail()
    },[])

    React.useEffect(()=>{
        if(adminstate.length>0){
        getReferrals()
        }
    },[adminstate])

    const getAdminDetail=()=>{
        let dataToSend = {admin_id : admindata.admin_id };
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/get_admin_detail`;
       
         axios.post(full_api, dataToSend, { headers: exportValue.headers }).then((res) => {
                if(res.data.status==true){
                    setadminState(res.data.output)
        }
       else{
           const Toast = Swal.mixin({
               toast: true,
               position: 'bottom-end',
               showConfirmButton: false,
               timer: 3000
             })
             Toast.fire({
               background:"#a61c09",
               type: 'Unsuccess',
               title: "Something Went Wrong !",
               color:"white"
             });
       } 
    })  .catch((error) => {
               const Toast = Swal.mixin({
                   toast: true,
                   position: 'bottom-end',
                   showConfirmButton: false,
                   timer: 3000
                 })
                 Toast.fire({
                   background:"#a61c09",
                   type: 'Unsuccess',
                   title: "Something Went Wrong !",
                   color:"white"
                 });
                 // console.log(error);
             });    
       
       }

        const getReferrals=()=>{
            let id =""
            if(adminstate.length>0){
                if(adminstate[0].am_id){
                    id = adminstate[0].am_id
                }
                else if(adminstate[0].ndr_id){
                    id = adminstate[0].ndr_id
                }
            }
            let dataToSend = {admin_id : admindata.admin_id, id:id};
            let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/get_my_earnings`;
           
             axios.post(full_api, dataToSend, { headers: exportValue.headers }).then((res) => {
                    if(res.data.status==true){
                    setState(res.data.output)
            }
           else{
              
           } 
        })
               
                 .catch((error) => {
                   const Toast = Swal.mixin({
                       toast: true,
                       position: 'bottom-end',
                       showConfirmButton: false,
                       timer: 3000
                     })
                     Toast.fire({
                       background:"#a61c09",
                       type: 'Unsuccess',
                       title: "Something Went Wrong !",
                       color:"white"
                     });
                     // console.log(error);
                 });    
           
           }
           const handleRowClick = (item) => {
            setSelectedItem(item); // Store clicked item data in state
          };
  return (
    <div>
          <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
       
       <section class="home-section">
       <Sub_header/>
       <div class="row justify-content-between">
    <div class="col-12 col-md-4 desk_nav">
      <div class="d-flex">
        {/* <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a> */}
        <h2>My Earnings</h2>
      </div>
    </div>
</div>




<div class="modal" id="myEarning" data-bs-backdrop="false">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Monthly Earning - {selectedItem!=null?selectedItem.generated_on:""}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
      {selectedItem ? (
                <table className="table table-bordered">
                  <thead>
                    <tr className="table-primary">
                      <th>Client Name</th>
                      <th>Total Eligible Orders</th>
                      <th>Total Earnings</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItem.referred_customers.map((sub)=>(
                    <tr>
                      <td>{sub.referred_customer_name}</td>
                      <td>{sub.orders}</td>
                      <td>₹{sub.earnings}</td>
                    </tr>
                    ))}
                    <tr>
                      <td colSpan="2" className="text-end fw-bold fs-5">
                        Total
                      </td>
                      <td className="fw-bold fs-5">₹{selectedItem.total_earnings}</td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <p>No data available</p>
              )}
      </div>
    </div>
  </div>
</div>
<div class="card border-0">
  <div class="card-body">
    <table class="table table-bordered">
        <thead>
          <tr>
            <th>Month</th>
            <th>Total Eligible Orders</th>
            <th>Total Earnings</th>
          </tr>
        </thead>
        <tbody>
            {state.map((item)=>(
          <tr>
            <td><a href="#" class="text-primary" data-bs-toggle="modal" data-bs-target="#myEarning" data-bs-backdrop="false" onClick={() => handleRowClick(item)}>{item.generated_on}</a></td>
            <td>{item.total_orders}</td>
            <td>₹{item.total_earnings}</td>
          </tr>
          ))}
         
        </tbody>
      </table>
  </div>
</div>
       </section>
    </div>
  )
}

export default My_earnings
